$(function() {
  'use strict';

  $('.floating-labels .form-control').on('focus blur', function(e) {
    $(this).
        parents('.form-group').
        toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
  }).trigger('blur');

  $(function() {
    $('[data-toggle="tooltip"]').tooltip();
  });
  $(function() {
    $('[data-toggle="popover"]').popover();
  });

  // $('body').trigger('resize');

  $('#to-recover').on('click', function() {
    $('#loginform').slideUp();
    $('#recoverform').fadeIn();
  });
});
